module.exports = __webpack_public_path__ + "assets/img/title.907a6e03.png";